import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export function BackButton() {
  const handleBack = () => {
    window.history.back();
  }
  
  return (
    <Button onClick={handleBack} size="sm">
        <ArrowLeft />
    </Button>
  );
}